import { render } from "./Cabecalho.vue?vue&type=template&id=4261f0dc"
const script = {}

import "./Cabecalho.vue?vue&type=style&index=0&id=4261f0dc&lang=css"
script.render = render

export default script